var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,{directives:[{name:"editable",rawName:"v-editable",value:(_vm.item),expression:"item"}],tag:"component",attrs:{"item":_vm.item}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }